import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'windState';

const initialState = {
    wind: {},
    status: 'idle',
    error: null,
};

export const getWind = createAsyncThunk(
    'windState/getWind',
    async (_, { getState, rejectWithValue }) => {
        try {
            const windStationId = getState().deviceState.activeDevice.windStationId;
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/adminOptions/wind/${windStationId}`,
                withCredentials: true,
                auth: createAuth(getState)
            });
            return { ...response.data };
        } catch (error) {
            console.log('ERROR FETCHING WIND', error);
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const windSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            //getWind
            .addCase(getWind.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getWind.fulfilled, (state, action) => {
                state.wind = action.payload;
                state.status = 'succeeded';
            })
            .addCase(getWind.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export default windSlice.reducer;